import type { TranslationKey } from '@/lib/i18n';

export const COUNTRY_SELECTOR_ACCESSIBILITY_SELECT = [
  'common:header.selectCountry',
  'Select country',
] as const satisfies TranslationKey;

export const COUNTRY_SELECTOR_LABEL_COUNTRY_CURRENCY = [
  'common:header.countryAndCurrency',
  'Country & currency',
] as const satisfies TranslationKey;

export const COUNTRY_SELECTOR_ACCESSIBILITY_COUNTRY_LIST = [
  'common:header.countryList',
  'Country list',
] as const satisfies TranslationKey;
